import { Button } from "Components/Button";
import { RefreshCw } from "lucide-react";

import { ProductAdded } from "Requests/Partners/PreBudgets";
import { formatBRLCurrency } from "Utils/FormatCurrency";

interface CartItemWithReplacementProps {
  product: ProductAdded & {
    source?: "ia" | "manual";
    originalIAProduct?: {
      nome_enviado: string;
      nome_encontrado: string;
      id_encontrado: number | null;
    };
  };
  addUnitItem: (productId: number) => void;
  removeUnitItem: (productId: number) => void;
  deleteItem: (productId: number) => void;
  loadingOp: boolean;
  blockedUserInteraction?: boolean;
  onReplace?: (productId: number) => void;
}

export const CartItemWithReplacement = ({
  product,
  addUnitItem,
  loadingOp,
  removeUnitItem,
  blockedUserInteraction,
  deleteItem,
  onReplace,
}: CartItemWithReplacementProps) => {
  const handleDecreaseQuantity = () => {
    if (product.amount <= 1) {
      deleteItem(product.product_id);
    } else {
      removeUnitItem(product.product_id);
    }
  };

  const handleReplace = () => {
    if (onReplace) {
      onReplace(product.product_id);
    }
  };

  const isIAProduct = product.source === "ia";

  return (
    <div className="cart-item cart-item-with-replacement">
      <p className="label">
        {product.product_code && `${product.product_code}`} <br />
        {product.product_name}{" "}
        <span className="ia-tag-container">
          {isIAProduct && (
            <span className="ia-tag" title="Produto adicionado via IA">
              [IA]
            </span>
          )}
          {/* Botão de substituição - só para produtos da IA */}
          {isIAProduct && onReplace && (
            <Button
              type="button"
              onClick={handleReplace}
              textButton
              disabled={blockedUserInteraction}
            >
              <RefreshCw size={16} />
            </Button>
          )}
        </span>
      </p>
      <div className="action">
        <div className="amount space-buttons">
          <Button
            loading={loadingOp}
            type="button"
            onClick={handleDecreaseQuantity}
            textButton
            disabled={blockedUserInteraction}
          >
            -
          </Button>

          <span className="_number product-quantity">{product.amount}</span>

          <Button
            loading={loadingOp}
            type="button"
            onClick={() => addUnitItem(product.product_id)}
            textButton
            disabled={blockedUserInteraction}
          >
            +
          </Button>
        </div>

        <p className="price unit">
          R$ {formatBRLCurrency(product.amount * product.product_price)}
        </p>
      </div>
    </div>
  );
};
